module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAACXBIWXMAAAsSAAALEgHS3X78AAAAk0lEQVQY03XOsQ3CQAyF4Z9TelaACaC1rmGEbEA2YIWMkGxANmAEkC6+OhuwAhOYAiNFcGfJeq/4JBszo7RJdUiqllQ7M2NjZvzOnPPg9eK5bwroCpyBFzACxyjyDBU0AltgF0VOAKGCOmDxBPj8uEIT0AK3KNKtr4U5597R4vmHvqdb7wdgKiGAxsEDuEeRnsq8AahQSXcSWO7oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/public/images/edit_menuItem.png
// module id = 878
// module chunks = 0